import { TableCell } from '@mui/material';
import { Avatar } from '@shared/ui/parts';

export default function MemberTeamCell({ row }) {
  return (
    <TableCell>
      <div className="memberTeamCell">
        <p>{row.owner?.name}</p>
        <div className="memberTeamCell__team">
          <Avatar team={row.group} />
          <p className="secondary-text">{row.group?.name}</p>
        </div>
      </div>
    </TableCell>
  );
}
